<table *ngIf="teacherStats && teacherStats.length > 0;else noStatsInfo" mat-table multiTemplateDataRows
       [dataSource]="teacherStats" class="mat-elevation-z4 full-width">

  <!-- User Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'name' title@@users-list-item-name-title">Name:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="name column-content word-wrap mat-body">
      {{element.firstName}} {{element.lastName}}
    </td>
  </ng-container>

  <!-- Email Column -->
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'email' title@@users-list-item-email-title">Email:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="email column-content word-wrap mat-body">
      {{element.email}}
    </td>
  </ng-container>

  <!-- Phone Column -->
  <ng-container matColumnDef="phone">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'phone' title@@users-list-item-phone-title">Phone:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="phone column-content word-wrap mat-body">
      <ng-container *ngIf="element.phone;else noPhone">{{element.phone}}</ng-container>
      <ng-template #noPhone>
        <ng-container i18n="General|No data provided@@general-no-data-provided">[no data]</ng-container>
      </ng-template>
    </td>
  </ng-container>

  <!-- Enrolled Column -->
  <ng-container matColumnDef="enrolled-at">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'enrolled-at' title@@users-list-item-enrolled-at-title">Enrolled At:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="enrolled-at column-content word-wrap mat-body">
      <ng-container *ngIf="element.enrolledAt;else noEnrolled">{{element.enrolledAt | date: 'medium'}}</ng-container>
      <ng-template #noEnrolled>
        <ng-container i18n="General|No data provided@@general-no-data-provided">[no data]</ng-container>
      </ng-template>
    </td>
  </ng-container>

  <!-- Region Column -->
  <ng-container matColumnDef="region">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'region' title@@users-list-item-region-title">Region:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="region column-content word-wrap mat-body">
      {{regions.get(element.regionId)}}
    </td>
  </ng-container>

  <!-- School Name Column -->
  <ng-container matColumnDef="school">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'school' title@@users-list-item-school-title">School:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="school column-content word-wrap mat-body">
      {{element.schoolName}}
    </td>
  </ng-container>

  <!-- Students Participated Column -->
  <ng-container matColumnDef="students">
    <th mat-header-cell *matHeaderCellDef class="column-header">
          <span class="students word-wrap"
                i18n="Stats Dashboard|Stats students participated count title@@stats-dashboard-stats-students-participated-count-title">Participated:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="students column-content mat-body">
      <span class="numeric-data">{{element.studentsCount}}</span>
    </td>
  </ng-container>

  <!-- Students Enrolled Column -->
  <ng-container matColumnDef="enrolled">
    <th mat-header-cell *matHeaderCellDef class="column-header">
          <span class="enrolled word-wrap mat-body"
                i18n="Stats Dashboard|Stats students enrolled count title@@stats-dashboard-stats-students-enrolled-count-title">Enrolled:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="enrolled column-content mat-body">
      <span class="numeric-data">{{element.enrolledStudentsCount}}</span>
    </td>
  </ng-container>

  <!-- Points Column -->
  <ng-container matColumnDef="points">
    <th mat-header-cell *matHeaderCellDef class="column-header">
            <span class="word-wrap"
                  i18n="Stats Dashboard|Exam Card Stats rating points title@@stats-dashboard-exam-card-rating-points-title">Rating points:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="column-content mat-body-strong" [class.points]="!mobileView">
      <span class="numeric-data">{{element.points}}</span>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
      <div *ngIf="expandContent" class="teacher-element-detail"
           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        <school-teachers-info [mobileView]="mobileView"
                              [regions]="regions"
                              [competitionId]="competitionId"
                              [contest]="contest"
                              [regionId]="element.regionId"
                              [schoolId]="element.schoolId"
                              [loadData]="element == expandedElement"
                              class="school-teachers-details"></school-teachers-info>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="teacher-element-row"
      [class.teacher-expanded-row]="expandedElement === element"
      [class.no-expand]="!expandContent"
      (click)="expandedElement = expandedElement === element ? null : element"></tr>
  <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="teacher-detail-row"></tr>
</table>

<ng-template #noStatsInfo>
  <app-no-content *ngIf="!inProgress && contest"
                  [compact]="true"
                  title="No statistical data available at the moment"
                  i18n-title="Stats|User exam card stats missing title@@stats-user-exam-card-stats-missing-title"
                  details="Stats will be populated after students participate in the contest"
                  i18n-details="Stats|Users exam stats missing details@@stats-users-exam-stats-missing-details"></app-no-content>
</ng-template>
